import CampaignWarrantyPanel from './campaignWarrantyPanel.container';

export default CampaignWarrantyPanel;